import React, { useEffect, useState } from 'react'
import API from '../../services/API'
import { Box, Grid, Skeleton, Typography } from '@mui/material'
import { Description } from '@mui/icons-material'

const getFileType = (url) => {
  const cleanUrl = url.split('?')[0].toLowerCase()
  if (cleanUrl.endsWith('.pdf')) return 'pdf'
  if (cleanUrl.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/)) return 'image'
  return 'other'
}

const AttachmentPreview = ({ s3key, onClick }) => {
  const [attachment, setAttachment] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const fileType = getFileType(s3key)

  useEffect(() => {
    if (!s3key) return
    if (fileType === 'pdf') {
      setIsLoading(false)
      return
    }
    API.post('/gets3downloadUrl', {
      key: s3key,
      inlineView: true,
    })
      .then((res) => setAttachment(res.data))
      .finally(() => setIsLoading(false))
  }, [])

  return (
    <Grid item xs={12} md={6} lg={3}>
      <Box
        sx={{
          borderRadius: 2,
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'grey.300',
          cursor: 'pointer',
          transition: '0.2s',
          '&:hover': { borderColor: 'anBlue.main', boxShadow: 2 },
        }}
        onClick={() => onClick(s3key)}
      >
        {isLoading && <Skeleton />}
        {fileType === 'image' && (
          <img
            src={attachment}
            alt="Attachment Preview"
            style={{
              width: '100%',
              height: 180,
              objectFit: 'cover',
              display: 'block',
            }}
          />
        )}

        {fileType === 'pdf' && (
          <Box
            sx={{
              height: 180,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              bgcolor: 'grey.100',
            }}
          >
            <Description sx={{ width: 48, opacity: 0.7, marginBottom: 8 }} />
            <Typography variant="caption" sx={{ textAlign: 'center', px: 1 }}>
              PDF Document
            </Typography>
          </Box>
        )}

        {fileType === 'other' && (
          <Box
            sx={{
              height: 180,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'grey.100',
              flexDirection: 'column',
            }}
          >
            <Description sx={{ width: 40, opacity: 0.7, marginBottom: 6 }} />
            <Typography variant="caption" sx={{ textAlign: 'center' }}>
              File
            </Typography>
          </Box>
        )}
      </Box>
    </Grid>
  )
}

export default AttachmentPreview
